import { TransactionSource, TransactionType } from "@goodfill/domain-properties";
import { DateTime } from "luxon";
import { PresentedDepositHistoryTransaction } from "../PresentedDepositHistoryTransaction";
import { FilterFunction } from "../../../../../filters/filters";

export interface PortfolioDepositHistoryFilter {
  transactedAtSince: DateTime | null;
  transactedAtTill: DateTime | null;
  type: TransactionType | null;
  source: TransactionSource | null;
}

export const defaultPortfolioDepositHistoryFilterConstraints: PortfolioDepositHistoryFilter = {
  transactedAtSince: null,
  transactedAtTill: null,
  type: null,
  source: null,
};

export const transactedAtFilter = (
  item: Pick<PresentedDepositHistoryTransaction, "transactedAt">,
  constrains: Pick<PortfolioDepositHistoryFilter, "transactedAtSince" | "transactedAtTill">,
) => {
  const transactedAtSince = constrains.transactedAtSince?.set({ hour: 0, minute: 0, second: 0 }) ?? null;
  const transactedAtTill =
    constrains.transactedAtTill?.set({ hour: 0, minute: 0, second: 0 }).plus({ days: 1 }) ?? null;

  const upperBound = transactedAtTill === null || transactedAtTill >= item.transactedAt;
  const lowerBound = transactedAtSince === null || transactedAtSince <= item.transactedAt;

  return upperBound && lowerBound;
};

export const portfolioDepositHistoryFilters: FilterFunction<
  PresentedDepositHistoryTransaction,
  PortfolioDepositHistoryFilter
>[] = [
  transactedAtFilter,
  (item, constrains) => constrains.type === null || constrains.type === item.type,
  (item, constrains) => constrains.source === null || constrains.source === item.source,
];
